import React from 'react';
import { useGetEscrowBalancesDataQuery } from '../../../../API/order/escrow/EscrowBaseAPI';
import { ExpectedCard } from './ExpectedCard';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { Spinner } from '../../../../ui-toolkit';

interface IExpectedContainerProps {
  orderId: string;
}

export const ExpectedContainer: React.FC<IExpectedContainerProps> = ({ orderId }) => {
  const { data: expectedDetails, isLoading, isSuccess } = useGetEscrowBalancesDataQuery(orderId);
  const { data: orderDetails } = useSelectCurrentOrder();

  return (
    <>
      {isLoading && <Spinner />}
      {isSuccess && expectedDetails && (
        <ExpectedCard
          borrowerMoney={expectedDetails.expectedBorrowerCashToCloseAmountDollars}
          buyerMoney={expectedDetails.expectedBuyerCashToCloseAmountDollars}
          lenderMoney={expectedDetails.expectedIncomingLenderAmountDollars}
          sellerMoney={expectedDetails.expectedSellerCashToCloseAmountDollars}
          transactionType={orderDetails.transaction.transaction_category}
          loanAmount={orderDetails.transaction.loan_amount}
        />
      )}
    </>
  );
};
